import { createGlobalStore } from 'hox';
import { useCallback, useState } from 'react';
import { GlobalApi } from '../apis';
import { isInUIC } from '../utils/common';
import { IsAdvancedInfo } from '../pages/Welcome/EmailAndCollaboration';

interface License {
  tenantId?: string;
  'CAS-SF'?: { enabled: boolean; type?: string };
  'CAS-XDR-ADDON'?: { enabled: boolean };
  CAS?: { enabled: boolean; type?: string; expirationDate?: string };
  'TMCAS-EMAIL-ADDON'?: { enabled: boolean };
}

function useLicense() {
  const [license, setLicense] = useState<License>({
    tenantId: 'tm',
    'CAS-XDR-ADDON': { enabled: false },
    CAS: { enabled: false, type: '' },
    'CAS-SF': { enabled: false, type: '' },
    'TMCAS-EMAIL-ADDON': { enabled: false },
  });

  const hasEmailAddOnLicense =
    (license['TMCAS-EMAIL-ADDON'] && license['TMCAS-EMAIL-ADDON'].enabled) ||
    false;
  const hasUpgradeV1License = (license.CAS && license.CAS.enabled) || false;
  const hasEaiAddOnLicense =
    (license['CAS-XDR-ADDON'] && license['CAS-XDR-ADDON'].enabled) || false;
  const hasSalesforceLicense =
    (license['CAS-SF'] && license['CAS-SF'].enabled) || false;

  const hasCasLicense = !!license?.CAS?.enabled;

  const fetchLicense = useCallback(async () => {
    if (isInUIC()) {
      const uicAdvancedInfoString =
        localStorage.getItem('uic_advancedInfo') || '{}';
      const uicAdvancedInfo: IsAdvancedInfo = JSON.parse(uicAdvancedInfoString);
      const type = uicAdvancedInfo.isPaid === 0 ? 'trail' : 'full';

      setLicense({
        'CAS-XDR-ADDON': { enabled: true },
        CAS: { enabled: true, type },
        'CAS-SF': { enabled: false },
        'TMCAS-EMAIL-ADDON': { enabled: true },
      });
    } else {
      const license = (await GlobalApi.getLicense()).data;
      setLicense(license);
    }
  }, []);

  return {
    license,
    hasEmailAddOnLicense,
    hasEaiAddOnLicense,
    hasUpgradeV1License,
    hasCasLicense,
    hasSalesforceLicense,
    fetchLicense,
  };
}
export const [useLicenseStore] = createGlobalStore(useLicense);
